import { CanDeactivateFn, Routes } from '@angular/router';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { authGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login.component';
import { CameraPopoutComponent } from './component/camera-popout/camera-popout.component';
import { JobDetailComponent } from './component/job-detail/job-detail.component';
import { JobsListComponent } from './component/jobs-list/jobs-list.component';
import { LayoutComponent } from './component/layout/layout.component';
import { PropertyPhotosComponent } from './component/property-photos/property-photos.component';
import { NotFoundComponent } from './component/shared/not-found.component';

const canDeactivateJobDetail: CanDeactivateFn<JobDetailComponent> = (component) => component.canDeactivate();

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  { path: 'TRK_Tracker.aspx', component: AuthCallbackComponent },
  { path: 'jobs/:jobId/camera-popout', component: CameraPopoutComponent, canActivate: [authGuard] },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: JobsListComponent },
      { path: 'jobs/:id', component: JobDetailComponent, canDeactivate: [canDeactivateJobDetail] },
      { path: 'jobs/:jobId/photos', component: PropertyPhotosComponent },
      { path: '**', component: NotFoundComponent },
    ],
  },
];
